import React, { useEffect, useState, useMemo } from 'react';
import {
  Box, Typography, Card, CardContent, Grid, Chip,
  CircularProgress, Alert, TextField, InputAdornment,
  Tabs, Tab, Button, Dialog, DialogTitle, DialogContent,
  DialogActions, Select, MenuItem, FormControl, InputLabel,
  Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Paper, Collapse, Autocomplete, IconButton
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import WarningIcon from '@mui/icons-material/Warning';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import EditIcon from '@mui/icons-material/Edit';
import MegaScanPanel from '../components/MegaScanPanel';
import OfertaEditor from '../components/OfertaEditor';
import PedidosCliente from '../components/PedidosCliente';
import { QRCodeSVG } from 'qrcode.react';
import * as XLSX from 'xlsx';
import api, {
  getRecambios, exportarRecambios, getAlertasStock, getMovimientos,
  getProveedores, crearMovimiento, crearRecambio,
  crearProveedor, getClientes, crearOferta, confirmarVenta,
  getOfertas, descargarAlbaran, buscarRecambioPorReferencia,
  getRecambiosDivision, getDivisionesStock, actualizarRecambio, aceptarOferta, borrarOferta
} from '../api';

export default function Almacen() {
  const [tab, setTab] = useState(0);
  const [recambios, setRecambios] = useState<any[]>([]);
  const [movimientos, setMovimientos] = useState<any[]>([]);
  const [proveedores, setProveedores] = useState<any[]>([]);
  const [alertas, setAlertas] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [division, setDivision] = useState('');
  const [conteoDiv, setConteoDiv] = useState<Record<string, number>>({});
  const [editRecambio, setEditRecambio] = useState<any>(null);
  const [ofertaEditorOpen, setOfertaEditorOpen] = useState(false);
  const [ofertaEditando, setOfertaEditando] = useState<any>(null);
  const [alertasOpen, setAlertasOpen] = useState(false);
  const [movDialog, setMovDialog] = useState<any>(null);
  const [movDatos, setMovDatos] = useState({ tipo: 'entrada', cantidad: 1, motivo: 'Stock almacén', cliente: '', albaran: '' });
  const [provDialog, setProvDialog] = useState(false);
  const [provDatos, setProvDatos] = useState({ nombre: '', cif: '', email: '', telefono: '', contacto: '', condiciones_pago: '30 días', descuento: 0 });
  const [clientesLista, setClientesLista] = useState<any[]>([]);
  const [ofertaGenerada, setOfertaGenerada] = useState<any>(null);
  const [ofertas, setOfertas] = useState<any[]>([]);
  const [carrito, setCarrito] = useState<{recambio: any, cantidad: number}[]>([]);
  const [qrDialog, setQrDialog] = useState<any>(null);
  const [scanResult, setScanResult] = useState<any>(null);
  const [scanning, setScanning] = useState(false);
  const [carritoOpen, setCarritoOpen] = useState(false);
  const [datosVentaCarrito, setDatosVentaCarrito] = useState({
    cliente: '', clienteId: null as number | null, descuento: 0,
    condiciones: 'Transferencia 30 días', observaciones: ''
  });
  const [pdfBytes, setPdfBytes] = useState<Blob | null>(null);
  const [recDialog, setRecDialog] = useState(false);
  const [recEditando, setRecEditando] = useState<any>(null);
  const [recDatos, setRecDatos] = useState<any>({
    referencia: '', nombre: '', descripcion: '', categoria: 'Otro',
    division: 'General', modelos_compatibles: '', precio_compra: '',
    precio_venta: '', ubicacion_almacen: '', stock_minimo: 1, stock_inicial: 0,
  });

  // ── FILTROS MOVIMIENTOS ───────────────────────────────────
  const [movFiltros, setMovFiltros] = useState({
    tipo: '', fecha_inicio: '', fecha_fin: '', recambio: '', usuario_id: 0, motivo: ''
  });
  const [movPage, setMovPage] = useState(1);
  const [movTotalPages, setMovTotalPages] = useState(1);
  const [movTotal, setMovTotal] = useState(0);
  const [usuarios, setUsuarios] = useState<any[]>([]);

  // ── PERMISOS ──────────────────────────────────────────────
  const [permisos, setPermisos] = useState<string[]>([]);
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const esAdmin = user.rol === 'admin';

  // Capacidades derivadas — SOLO admin tiene todo por defecto
  const tieneModuloAlmacen  = esAdmin || permisos.includes('ver_almacen');
  const puedeGestionarStock     = esAdmin || permisos.includes('almacen_gestionar_stock');
  const puedeDarEntrada         = puedeGestionarStock;
  const puedeDarSalida          = puedeGestionarStock;
  const puedeSoloSolicitar      = !puedeGestionarStock && permisos.includes('almacen_solo_solicitar');
  const puedeRecibirSolicitudes = esAdmin || permisos.includes('almacen_recibir_solicitudes');
  const puedeVerSolicitudes = puedeRecibirSolicitudes || puedeSoloSolicitar || puedeDarSalida;

  // ── SOLICITUDES (declaración adelantada para que TABS pueda usarla) ──
  const [solicitudes, setSolicitudes] = useState<any[]>([]);

  // ── TABS DINÁMICAS ────────────────────────────────────────
  // Construimos el array de tabs visibles según permisos.
  // Así el índice siempre coincide con lo que se renderiza.
  const TABS = useMemo(() => {
    const t: { id: string; label: string }[] = [];
    if (tieneModuloAlmacen) t.push({ id: 'recambios', label: '📦 Stock' });
    if (tieneModuloAlmacen) t.push({ id: 'megascan', label: '🪄 MegaScan' });
    if (puedeDarSalida)     t.push({ id: 'oportunidades', label: '📄 Ofertas' });
    if (puedeDarSalida)     t.push({ id: 'pedidos', label: '🚚 Pedidos' });
    if (puedeDarEntrada || puedeDarSalida) t.push({ id: 'movimientos', label: '📊 Movimientos' });
    if (puedeVerSolicitudes) {
      const pendientes = solicitudes.filter(s => s.estado === 'pendiente').length;
      t.push({ id: 'solicitudes', label: `📋 Solicitudes${pendientes > 0 ? ` (${pendientes})` : ''}` });
    }
    return t;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permisos, esAdmin, solicitudes]);

  const tabActual = TABS[tab]?.id || '';

  // ── SOLICITUDES ───────────────────────────────────────────
  const [solicitudDialog, setSolicitudDialog] = useState<any>(null);
  const [aprobarDialog, setAprobarDialog] = useState<any>(null);
  const [aprobarLineas, setAprobarLineas] = useState<any[]>([]);
  const [intervencionesAbiertas, setIntervencionesAbiertas] = useState<any[]>([]);
  const [solicitudDatos, setSolicitudDatos] = useState({
    cantidad: 1, motivo: '', cliente: '', clienteId: null as number | null,
    tipo_salida: 'salida_obra', intervencion_id: null as number | null
  });
 
  const cargarSolicitudes = () => {
    api.get('/solicitudes-almacen').then(r => setSolicitudes(r.data)).catch(() => {});
  };

  const handleCrearSolicitud = async () => {
    if (!solicitudDialog) return;
    try {
      await api.post('/solicitudes-almacen', {
        motivo: solicitudDatos.motivo,
        cliente: solicitudDatos.cliente,
        cliente_id: solicitudDatos.clienteId,
        tipo_salida: solicitudDatos.tipo_salida,
        intervencion_id: solicitudDatos.intervencion_id,
        lineas: [{ recambio_id: solicitudDialog.id, cantidad: solicitudDatos.cantidad }]
      });
      setSolicitudDialog(null);
      setSolicitudDatos({ cantidad: 1, motivo: '', cliente: '', clienteId: null, tipo_salida: 'salida_obra', intervencion_id: null })
      cargarSolicitudes();
      alert('✅ Solicitud enviada correctamente');
    } catch (e: any) {
      alert(e.response?.data?.detail || 'Error al enviar la solicitud');
    }
  };

  const handleResolverSolicitud = async (solicitudId: number, estado: 'aprobada' | 'rechazada') => {
    try {
      const result = await api.put(`/solicitudes-almacen/${solicitudId}`, {
        estado,
        lineas: aprobarLineas.map(l => ({ id: l.id, precio_unitario: l.precio_unitario }))
      });
      setAprobarDialog(null);
      cargarSolicitudes();
      cargarRecambios();
      getAlertasStock().then(setAlertas);
      getMovimientos().then(setMovimientos);
      getOfertas().then(setOfertas);
      // Si era venta cliente y se aprobó, ir a Oportunidades
      if (estado === 'aprobada' && aprobarDialog?.tipo_salida === 'venta_cliente') {
        setTab(TABS.findIndex(t => t.id === 'oportunidades'));
      }
    } catch (e: any) {
      alert(e.response?.data?.detail || 'Error al resolver la solicitud');
    }
  };

  // ── CARGA DE DATOS ────────────────────────────────────────
  const cargarMovimientos = () => {
    const params = new URLSearchParams();
    if (movFiltros.tipo) params.append('tipo', movFiltros.tipo);
    if (movFiltros.fecha_inicio) params.append('fecha_inicio', movFiltros.fecha_inicio);
    if (movFiltros.fecha_fin) params.append('fecha_fin', movFiltros.fecha_fin);
    if (movFiltros.recambio) params.append('recambio', movFiltros.recambio);
    if (movFiltros.usuario_id) params.append('usuario_id', String(movFiltros.usuario_id));
    if (movFiltros.motivo) params.append('motivo', movFiltros.motivo);
    params.append('page', String(movPage));
    api.get(`/movimientos?${params.toString()}`).then(r => {
      setMovimientos(r.data.items);
      setMovTotalPages(r.data.pages);
      setMovTotal(r.data.total);
    });
  };

  const cargarRecambios = () => {
    setLoading(true);
    getRecambiosDivision(search, page, division)
      .then(data => { setRecambios(data.items); setTotalPages(data.pages); })
      .finally(() => setLoading(false));
    getDivisionesStock().then((d: any) => setConteoDiv(d.conteo || {})).catch(() => {});
  };

  useEffect(() => { cargarRecambios(); }, [search, page, division]);

    const handleBorrarOferta = async (o: any) => {
    if (!window.confirm(`¿Eliminar la oferta ${o.numero}? Esta acción no se puede deshacer.`)) return;
    try {
      await borrarOferta(o.id);
      getOfertas().then(setOfertas);
    } catch (e: any) {
      alert(e.response?.data?.detail || 'Error al eliminar la oferta');
    }
  };

    const handleAceptarOferta = async (o: any) => {
    if (!window.confirm(
      `¿Aceptar la oferta ${o.numero}?\n\n` +
      `Se creará el pedido de cliente, se reservará el stock disponible y ` +
      `lo que falte se pedirá al proveedor.`)) return;
    try {
      const r = await aceptarOferta(o.id);
      let msg = `✅ Pedido ${r.numero} creado.`;
      if (r.pedidos_compra?.length) {
        msg += `\n\nPedidos a proveedor generados: ${r.pedidos_compra.join(', ')}`;
      }
      alert(msg);
      getOfertas().then(setOfertas);
      cargarRecambios();
    } catch (e: any) {
      alert(e.response?.data?.detail || 'Error al aceptar la oferta');
    }
  };

  const guardarRecambio = async () => {
    try {
      await actualizarRecambio(editRecambio.id, {
        referencia: editRecambio.referencia, nombre: editRecambio.nombre,
        division: editRecambio.division || 'General',
        ubicacion_almacen: editRecambio.ubicacion_almacen,
        modelos_compatibles: editRecambio.modelos_compatibles,
        precio_compra: parseFloat(editRecambio.precio_compra) || 0,
        precio_venta: parseFloat(editRecambio.precio_venta) || 0,
        stock_minimo: parseFloat(editRecambio.stock_minimo) || 0,
      });
      setEditRecambio(null);
      cargarRecambios();
    } catch (e: any) {
      alert(e.response?.data?.detail || 'Error al guardar el recambio');
    }
  };
  useEffect(() => { cargarMovimientos(); }, [movFiltros, movPage]);

  useEffect(() => {
    api.get('/me/permisos').then(r => setPermisos(r.data));
    api.get('/intervenciones/abiertas').then(r => setIntervencionesAbiertas(r.data)).catch(() => {});
    api.get('/usuarios/lista').then(r => setUsuarios(r.data)).catch(() => {});
    getAlertasStock().then(setAlertas);
    getProveedores().then(setProveedores);
    getClientes().then(setClientesLista);
    getOfertas().then(setOfertas);
    cargarSolicitudes();
  }, []);

  // Resetear tab a 0 cuando cambian los permisos para evitar tab fuera de rango
  useEffect(() => { setTab(0); }, [permisos]);

  // ── CARRITO ───────────────────────────────────────────────
  const añadirAlCarrito = (recambio: any) => {
    setCarrito(prev => {
      const existe = prev.find(item => item.recambio.id === recambio.id);
      if (existe) return prev.map(item => item.recambio.id === recambio.id ? { ...item, cantidad: item.cantidad + 1 } : item);
      return [...prev, { recambio, cantidad: 1 }];
    });
  };
  const quitarDelCarrito = (id: number) => setCarrito(prev => prev.filter(item => item.recambio.id !== id));
  const cambiarCantidadCarrito = (id: number, cantidad: number) =>
    setCarrito(prev => prev.map(item => item.recambio.id === id ? { ...item, cantidad: Math.max(1, cantidad) } : item));

  const calcularTotalCarrito = () => {
    const subtotal = carrito.reduce((sum, item) => sum + item.recambio.precio_venta * item.cantidad, 0);
    const desc = subtotal * (datosVentaCarrito.descuento || 0) / 100;
    const base = Math.round((subtotal - desc) * 100) / 100;
    const iva = Math.round(base * 0.21 * 100) / 100;
    return { base, iva, total: Math.round((base + iva) * 100) / 100 };
  };

  const calcularTotal = () => {
    const precio = (movDatos as any).precioOferta || movDialog?.precio_venta || 0;
    const subtotal = precio * movDatos.cantidad;
    const desc = subtotal * ((movDatos as any).descuento || 0) / 100;
    const base = Math.round((subtotal - desc) * 100) / 100;
    const iva = Math.round(base * 0.21 * 100) / 100;
    return { base, iva, total: Math.round((base + iva) * 100) / 100 };
  };

  // ── OFERTAS ───────────────────────────────────────────────
  const handleGenerarOfertaCarrito = async () => {
    const totales = calcularTotalCarrito();
    try {
      const result = await crearOferta({
        cliente: datosVentaCarrito.cliente, cliente_id: datosVentaCarrito.clienteId,
        descuento: datosVentaCarrito.descuento || 0, base_imponible: totales.base,
        cuota_iva: totales.iva, total: totales.total,
        condiciones_pago: datosVentaCarrito.condiciones, observaciones: datosVentaCarrito.observaciones,
        lineas: carrito.map(item => ({
          recambio_id: item.recambio.id, referencia: item.recambio.referencia,
          descripcion: item.recambio.nombre, cantidad: item.cantidad,
          precio_unitario: item.recambio.precio_venta, total: item.recambio.precio_venta * item.cantidad
        }))
      });
      setCarrito([]); setCarritoOpen(false);
      setDatosVentaCarrito({ cliente: '', clienteId: null, descuento: 0, condiciones: 'Transferencia 30 días', observaciones: '' });
      getOfertas().then(setOfertas);
      alert(`✅ Oferta ${result.numero} generada con ${carrito.length} recambio(s)`);
    } catch { alert('Error generando oferta'); }
  };

  const handleGenerarOferta = async () => {
    const totales = calcularTotal();
    try {
      const result = await crearOferta({
        cliente: movDatos.cliente, cliente_id: (movDatos as any).clienteId,
        descuento: (movDatos as any).descuento || 0, base_imponible: totales.base,
        cuota_iva: totales.iva, total: totales.total,
        condiciones_pago: (movDatos as any).condiciones || 'Transferencia 30 días',
        observaciones: (movDatos as any).observaciones || '',
        lineas: [{ recambio_id: movDialog.id, referencia: movDialog.referencia, descripcion: movDialog.nombre,
          cantidad: movDatos.cantidad, precio_unitario: (movDatos as any).precioOferta || movDialog.precio_venta,
          total: ((movDatos as any).precioOferta || movDialog.precio_venta) * movDatos.cantidad }]
      });
      setOfertaGenerada(result); getOfertas().then(setOfertas);
    } catch { alert('Error generando oferta'); }
  };

  const descargarPDF = async (url: string, nombre: string) => {
    const token = localStorage.getItem('token');
    const response = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await response.blob();
    const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = nombre; a.click();
    URL.revokeObjectURL(a.href);
  };

  const handleDescargarOferta = () => ofertaGenerada && descargarPDF(
    `${process.env.REACT_APP_API_URL}/ofertas/${ofertaGenerada.oferta_id}/pdf`, `${ofertaGenerada.numero}.pdf`
  ).catch(() => alert('Error descargando PDF'));

  const handleDescargarOfertaLista = (oferta: any) => descargarPDF(
    `${process.env.REACT_APP_API_URL}/ofertas/${oferta.id}/pdf`, `${oferta.numero}.pdf`
  ).catch(() => alert('Error descargando PDF'));

  const handleConfirmarVenta = async () => {
    if (!ofertaGenerada) return;
    try {
      await confirmarVenta(ofertaGenerada.oferta_id, {});
      setMovDialog(null); setOfertaGenerada(null);
      cargarRecambios(); getAlertasStock().then(setAlertas); getMovimientos().then(setMovimientos);
      alert('✅ Venta confirmada.');
    } catch { alert('Error confirmando venta'); }
  };

  const handleConfirmarVentaLista = async (oferta: any) => {
    if (!window.confirm(`¿Confirmar venta de ${oferta.numero}?`)) return;
    try {
      const result = await confirmarVenta(oferta.id, {});
      cargarRecambios(); getAlertasStock().then(setAlertas); getMovimientos().then(setMovimientos); getOfertas().then(setOfertas);
      if (window.confirm(`✅ Venta confirmada.\n¿Descargar albarán ahora?`)) {
        const blob = await descargarAlbaran(oferta.id);
        const a = document.createElement('a'); a.href = URL.createObjectURL(blob);
        a.download = `${result.albaran}.pdf`; a.click(); URL.revokeObjectURL(a.href);
      }
    } catch { alert('Error confirmando venta'); }
  };

  const handleMovimiento = async () => {
    if (!movDialog) return;
    try {
      await crearMovimiento({
        recambio_id: movDialog.id, tipo: movDatos.tipo, cantidad: movDatos.cantidad,
        precio_unitario: movDatos.tipo === 'entrada' ? movDialog.precio_compra : movDialog.precio_venta,
        motivo: movDatos.motivo, cliente: movDatos.cliente || null, albaran: movDatos.albaran || null,
        intervencion_id: (movDatos as any).intervencion_id || null
      });
      setMovDialog(null); cargarRecambios(); getAlertasStock().then(setAlertas); getMovimientos().then(setMovimientos);
    } catch (e: any) { alert(e.response?.data?.detail || 'Error'); }
  };

  const handleGuardarRecambio = async () => {
    const datos = {
      referencia: recDatos.referencia.trim(),
      nombre: recDatos.nombre.trim(),
      descripcion: recDatos.descripcion || null,
      categoria: recDatos.categoria || 'Otro',
      division: recDatos.division || 'General',
      modelos_compatibles: recDatos.modelos_compatibles || null,
      precio_compra: parseFloat(recDatos.precio_compra) || 0,
      precio_venta: parseFloat(recDatos.precio_venta) || 0,
      ubicacion_almacen: recDatos.ubicacion_almacen || null,
      stock_minimo: parseInt(recDatos.stock_minimo) || 1,
    };
    try {
      if (recEditando) {
        await actualizarRecambio(recEditando.id, datos);
      } else {
        const creado = await crearRecambio({ ...datos, stock_actual: 0 });
        const inicial = parseInt(recDatos.stock_inicial) || 0;
        // El stock entra como movimiento, nunca escrito a mano
        if (creado?.id && inicial > 0) {
          await crearMovimiento({
            recambio_id: creado.id, tipo: 'entrada', cantidad: inicial,
            precio_unitario: datos.precio_compra, motivo: 'Alta manual',
          });
        }
      }
      setRecDialog(false);
      setRecEditando(null);
      cargarRecambios();
    } catch (e: any) {
      alert('Error al guardar: ' + (e.response?.data?.detail || e.message || 'desconocido'));
    }
  };

  const handleProveedor = async () => {
    await crearProveedor(provDatos); setProvDialog(false); getProveedores().then(setProveedores);
  };

  React.useEffect(() => {
    if (scanning) {
      import('html5-qrcode').then(({ Html5QrcodeScanner }) => {
        const scanner = new Html5QrcodeScanner('qr-reader', { fps: 10, qrbox: 250 }, false);
        scanner.render(async (decodedText: string) => {
          try {
            const recambio = await buscarRecambioPorReferencia(decodedText);
            setScanResult(recambio); setScanning(false); scanner.clear();
          } catch { alert('Recambio no encontrado: ' + decodedText); }
        }, () => {});
        (window as any)._scanner = scanner;
      });
    } else {
      if ((window as any)._scanner) { try { (window as any)._scanner.clear(); } catch {} }
    }
  }, [scanning]);

    const exportarMovimientosExcel = async () => {
    try {
      const params = new URLSearchParams();
      if (movFiltros.tipo) params.append('tipo', movFiltros.tipo);
      if (movFiltros.fecha_inicio) params.append('fecha_inicio', movFiltros.fecha_inicio);
      if (movFiltros.fecha_fin) params.append('fecha_fin', movFiltros.fecha_fin);
      if (movFiltros.recambio) params.append('recambio', movFiltros.recambio);
      if (movFiltros.usuario_id) params.append('usuario_id', String(movFiltros.usuario_id));
      if (movFiltros.motivo) params.append('motivo', movFiltros.motivo);
      params.append('limit', '9999');
      const r = await api.get(`/movimientos?${params.toString()}`);
      const datos = r.data.items.map((m: any) => ({
        'Fecha': m.fecha?.slice(0, 10),
        'Tipo': m.tipo,
        'Referencia': m.referencia,
        'Recambio': m.recambio_nombre,
        'Cantidad': m.cantidad,
        'Precio unit. (€)': m.precio_unitario,
        'Total (€)': m.total,
        'Motivo': m.motivo || '—',
        'Cliente': m.cliente || '—',
        'Albarán': m.albaran || '—',
        'Usuario': m.usuario_nombre || '—',
      }));
      const ws = XLSX.utils.json_to_sheet(datos);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Movimientos');
      XLSX.writeFile(wb, `movimientos_${new Date().toISOString().slice(0,10)}.xlsx`);
    } catch {
      alert('Error exportando movimientos');
    }
  };

    const exportarInventarioExcel = async () => {
    try {
      const todos = await exportarRecambios();
      const datos = todos.map((r: any) => ({
        'Referencia': r.referencia,
        'Nombre': r.nombre,
        'Categoría': r.categoria || '—',
        'Stock actual': r.stock_actual,
        'Stock reservado': r.stock_reservado || 0,
        'Stock disponible': r.stock_actual - (r.stock_reservado || 0),
        'Stock mínimo': r.stock_minimo,
        'Precio compra (€)': r.precio_compra,
        'Precio venta (€)': r.precio_venta,
        'Ubicación': r.ubicacion_almacen || '—',
        'Modelos compatibles': r.modelos_compatibles || '—',
      }));
      const ws = XLSX.utils.json_to_sheet(datos);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Inventario');
      XLSX.writeFile(wb, `inventario_${new Date().toISOString().slice(0,10)}.xlsx`);
    } catch {
      alert('Error exportando el inventario');
    }
  };
  const motivosEntrada = ['Stock almacén', 'Devolución cliente', 'Ajuste inventario'];
  const motivosSalida  = ['Salida a obra', 'Venta cliente', 'Devolución a proveedor'];

  // ── RENDER ────────────────────────────────────────────────
  return (
    <Box sx={{ width: '100%', overflowX: 'hidden' }}>
      <Typography variant="h4" sx={{ fontWeight: 600, mb: 3, fontSize: { xs: '1.5rem', md: '2rem' } }}>📦 Almacén</Typography>

      {/* Alertas stock */}
      {alertas.length > 0 && (
        <Card sx={{ mb: 3, borderLeft: '4px solid #ef4444', borderRadius: 2 }}>
          <CardContent sx={{ py: 1.5 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
              onClick={() => setAlertasOpen(!alertasOpen)}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <WarningIcon color="error" />
                <Typography color="error" sx={{ fontWeight: 600 }}>{alertas.length} recambio(s) con stock bajo</Typography>
              </Box>
              {alertasOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Box>
            <Collapse in={alertasOpen}>
              <Box sx={{ mt: 1 }}>
                {alertas.map(a => (
                  <Alert key={a.id} severity="warning" sx={{ mb: 0.5, py: 0 }}>
                    <strong>{a.nombre}</strong> (Ref: {a.referencia}) — Stock: {a.stock_actual} / Mínimo: {a.stock_minimo}
                  </Alert>
                ))}
              </Box>
            </Collapse>
          </CardContent>
        </Card>
      )}

      {/* TABS DINÁMICAS */}
      <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile sx={{ mb: 3 }}>
        {TABS.map(t => <Tab key={t.id} label={t.label} />)}
      </Tabs>

      {/* TAB RECAMBIOS */}
      {tabActual === 'recambios' && (
        <Box>
          <Box sx={{ display: 'flex', justifyContent: { xs: 'stretch', sm: 'flex-end' }, gap: 1, mb: 2, flexWrap: 'wrap' }}>
            {puedeDarEntrada && (
              <Button variant="contained" startIcon={<AddIcon />}
                onClick={() => { setRecEditando(null); setRecDatos({
                  referencia: '', nombre: '', descripcion: '', categoria: 'Otro',
                  division: division && division !== 'todas' ? division : 'General',
                  modelos_compatibles: '', precio_compra: '', precio_venta: '',
                  ubicacion_almacen: '', stock_minimo: 1, stock_inicial: 0 }); setRecDialog(true); }}
                sx={{ bgcolor: '#4f46e5', width: { xs: '100%', sm: 'auto' } }}>
                Nuevo recambio
              </Button>
            )}
            <Button
              variant="outlined" startIcon={<span>📊</span>}
              onClick={exportarInventarioExcel}
              disabled={recambios.length === 0}
              sx={{ width: { xs: '100%', sm: 'auto' } }}
            >
              Exportar inventario Excel
            </Button>
          </Box>
          <Tabs value={division} onChange={(_, v) => { setDivision(v); setPage(1); }}
            variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile
            sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}>
            <Tab value="" label={`Todas (${Object.values(conteoDiv).reduce((a, b) => a + b, 0)})`} />
            {['SANY Cranes', 'SANY Robotics', 'SANY Marine', 'TII SCHEUERLE', 'General'].map(d => (
              <Tab key={d} value={d} label={`${d} (${conteoDiv[d] || 0})`} />
            ))}
          </Tabs>
          <TextField
            placeholder="Buscar por referencia o nombre..."
            value={search} onChange={(e) => { setSearch(e.target.value); setPage(1); }}
            size="small" sx={{ mb: 2, minWidth: 300 }}
            InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }}
          />
          {loading ? <CircularProgress /> : (
            <>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {recambios.length} recambios — Página {page} de {totalPages}
              </Typography>
              <Grid container spacing={2}>
                {recambios.map(r => (
                  <Grid item xs={12} sm={6} lg={4} key={r.id}>
                    <Card sx={{ borderRadius: 3, borderLeft: `3px solid ${r.stock_actual <= r.stock_minimo ? '#ef4444' : '#22c55e'}` }}>
                      <CardContent>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                          <Typography sx={{ fontWeight: 600, fontSize: 13 }}>{r.nombre}</Typography>
                          <Chip label={`Stock: ${r.stock_actual}${r.stock_reservado > 0 ? ` · ${r.stock_reservado} reserv.` : ''}`}
                            color={r.stock_actual <= r.stock_minimo ? 'error' : 'success'} size="small" />
                        </Box>
                        <Typography variant="caption" color="text.secondary" display="block">Ref: {r.referencia}</Typography>
                        {!division && (
                          <Typography variant="caption" color="text.secondary" display="block">🏷 {r.division || 'General'}</Typography>
                        )}
                        <Typography variant="caption" color="text.secondary" display="block">📍 {r.ubicacion_almacen || '—'}</Typography>
                        <Typography variant="caption" color="text.secondary" display="block">
                          💰 Compra: {r.precio_compra?.toFixed(2)}€ | Venta: {r.precio_venta?.toFixed(2)}€
                        </Typography>
                        {r.modelos_compatibles && (
                          <Typography variant="caption" color="text.secondary" display="block">🏗 {r.modelos_compatibles}</Typography>
                        )}

                        {/* BOTONES SEGÚN PERMISOS */}
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mt: 1 }}>
                          {puedeDarEntrada && (
                            <Box sx={{ display: 'flex', gap: 1 }}>
                              <IconButton size="small" title="Editar recambio"
                                onClick={() => {
                                  setRecEditando(r);
                                  setRecDatos({
                                    referencia: r.referencia || '', nombre: r.nombre || '',
                                    descripcion: r.descripcion || '', categoria: r.categoria || 'Otro',
                                    division: r.division || 'General',
                                    modelos_compatibles: r.modelos_compatibles || '',
                                    precio_compra: r.precio_compra ?? '', precio_venta: r.precio_venta ?? '',
                                    ubicacion_almacen: r.ubicacion_almacen || '',
                                    stock_minimo: r.stock_minimo ?? 1, stock_inicial: 0,
                                  });
                                  setRecDialog(true);
                                }}
                                sx={{ border: '1px solid #d1d5db', borderRadius: 1 }}>
                                <EditIcon fontSize="small" />
                              </IconButton>
                              <Button size="small" variant="outlined" fullWidth
                                onClick={() => { setMovDialog(r); setMovDatos({ tipo: 'entrada', cantidad: 1, motivo: 'Stock almacén', cliente: '', albaran: '' }); }}>
                                Movimiento
                              </Button>
                              <Button size="small" variant="contained" fullWidth sx={{ bgcolor: '#4f46e5' }} onClick={() => añadirAlCarrito(r)}>
                                🛒 Añadir
                              </Button>
                            </Box>
                          )}
                          {!puedeDarEntrada && puedeDarSalida && (
                            <Button size="small" variant="outlined" fullWidth color="error"
                              onClick={() => { setMovDialog(r); setMovDatos({ tipo: 'salida', cantidad: 1, motivo: 'Salida a obra', cliente: '', albaran: '' }); }}>
                              📤 Registrar salida
                            </Button>
                          )}
                          {puedeSoloSolicitar && (
                            <Button size="small" variant="outlined" fullWidth
                              sx={{ borderColor: '#f59e0b', color: '#f59e0b' }}
                              onClick={() => { setSolicitudDialog(r); setSolicitudDatos({ cantidad: 1, motivo: '', cliente: '', clienteId: null, tipo_salida: 'salida_obra', intervencion_id: null }); }}>
                              📋 Solicitar salida
                            </Button>
                          )}
                        </Box>
                        <Button size="small" variant="text" fullWidth sx={{ mt: 0.5 }}
                          startIcon={<QrCode2Icon fontSize="small" />} onClick={() => setQrDialog(r)}>
                          Ver QR
                        </Button>
                        {puedeGestionarStock && (
                          <Button size="small" variant="text" fullWidth onClick={() => setEditRecambio({ ...r })}>
                            ✏️ Editar
                          </Button>
                        )}
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
              <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
                <Button disabled={page === 1} onClick={() => setPage(p => p - 1)}>← Anterior</Button>
                <Typography sx={{ alignSelf: 'center' }}>Página {page} de {totalPages}</Typography>
                <Button disabled={page === totalPages} onClick={() => setPage(p => p + 1)}>Siguiente →</Button>
              </Box>
            </>
          )}
        </Box>
      )}
      {/* DIALOG EDITAR RECAMBIO */}
      <Dialog open={!!editRecambio} maxWidth="sm" fullWidth
        onClose={(e, r) => { if (r !== 'backdropClick' && r !== 'escapeKeyDown') setEditRecambio(null); }}>
        <DialogTitle>✏️ Editar recambio</DialogTitle>
        <DialogContent>
          {editRecambio && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField fullWidth label="Referencia" value={editRecambio.referencia || ''}
                  onChange={(e) => setEditRecambio({ ...editRecambio, referencia: e.target.value })} />
                <FormControl fullWidth>
                  <InputLabel>División</InputLabel>
                  <Select value={editRecambio.division || 'General'} label="División"
                    onChange={(e) => setEditRecambio({ ...editRecambio, division: e.target.value })}>
                    {['SANY Cranes', 'SANY Robotics', 'SANY Marine', 'TII SCHEUERLE', 'General'].map(d =>
                      <MenuItem key={d} value={d}>{d}</MenuItem>)}
                  </Select>
                </FormControl>
              </Box>
              <TextField fullWidth label="Nombre" value={editRecambio.nombre || ''}
                onChange={(e) => setEditRecambio({ ...editRecambio, nombre: e.target.value })} />
              <TextField fullWidth label="Modelos compatibles" value={editRecambio.modelos_compatibles || ''}
                onChange={(e) => setEditRecambio({ ...editRecambio, modelos_compatibles: e.target.value })} />
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField fullWidth label="Precio compra (€)" type="number" value={editRecambio.precio_compra ?? ''}
                  onChange={(e) => setEditRecambio({ ...editRecambio, precio_compra: e.target.value })} />
                <TextField fullWidth label="Precio venta (€)" type="number" value={editRecambio.precio_venta ?? ''}
                  onChange={(e) => setEditRecambio({ ...editRecambio, precio_venta: e.target.value })} />
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField fullWidth label="Stock mínimo" type="number" value={editRecambio.stock_minimo ?? ''}
                  onChange={(e) => setEditRecambio({ ...editRecambio, stock_minimo: e.target.value })} />
                <TextField fullWidth label="Ubicación en almacén" value={editRecambio.ubicacion_almacen || ''}
                  onChange={(e) => setEditRecambio({ ...editRecambio, ubicacion_almacen: e.target.value })} />
              </Box>
</Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditRecambio(null)}>Cancelar</Button>
          <Button variant="contained" onClick={guardarRecambio} sx={{ bgcolor: '#4f46e5' }}>Guardar</Button>
        </DialogActions>
      </Dialog>

      <OfertaEditor open={ofertaEditorOpen} oferta={ofertaEditando}
        onClose={() => { setOfertaEditorOpen(false); setOfertaEditando(null); }}
        clientes={clientesLista} proveedores={proveedores}
        onCreada={(r: any) => {
          alert(r.editada ? `✅ Oferta ${r.numero} actualizada` : `✅ Oferta ${r.numero} creada`);
          getOfertas().then(setOfertas);
        }} />

      {/* TAB MEGASCAN */}
      {tabActual === 'megascan' && (
        <MegaScanPanel
          onProductosListos={cargarRecambios}
          onAbrirMovimiento={(r) => { setMovDialog(r); setMovDatos({ tipo: 'entrada', cantidad: 1, motivo: 'Stock almacén', cliente: '', albaran: '' } as any); }}
          onAñadirCarrito={añadirAlCarrito}
          onSolicitarSalida={(r) => { setSolicitudDialog(r); setSolicitudDatos({ cantidad: 1, motivo: '', cliente: '', clienteId: null, tipo_salida: 'salida_obra', intervencion_id: null }); }}
          puedeDarEntrada={puedeDarEntrada}
          puedeSoloSolicitar={puedeSoloSolicitar}
        />
      )}

      {/* TAB OPORTUNIDADES */}
      {tabActual === 'oportunidades' && (
        <Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 1 }}>
            <Typography variant="body2" color="text.secondary">Ofertas pendientes de aceptar</Typography>
            <Button variant="contained" startIcon={<AddIcon />} onClick={() => { setOfertaEditando(null); setOfertaEditorOpen(true); }}
              sx={{ bgcolor: '#4f46e5' }}>
              Nueva oferta
            </Button>
          </Box>
          <Grid container spacing={2}>
            {ofertas.map(o => (
              <Grid item xs={12} sm={6} key={o.id}>
                <Card sx={{ borderRadius: 3, borderLeft: '4px solid #f59e0b' }}>
                  <CardContent>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                      <Typography sx={{ fontWeight: 600 }}>📄 {o.numero}</Typography>
                      <Chip label="Pendiente" color="warning" size="small" />
                    </Box>
                    <Typography variant="caption" display="block">👤 {o.cliente}</Typography>
                    <Typography variant="caption" display="block">📅 {o.fecha?.slice(0, 10)}</Typography>
                    <Typography variant="caption" display="block">💰 Total: {o.total?.toFixed(2)}€</Typography>
                    <Typography variant="caption" display="block">👷 {o.creado_por_nombre}</Typography>
                    <Box sx={{ display: 'flex', gap: 1, mt: 2, flexWrap: 'wrap' }}>
                      <Button size="small" variant="outlined" onClick={() => handleDescargarOfertaLista(o)}>⬇️ PDF</Button>
                      <Button size="small" variant="outlined" onClick={() => { setOfertaEditando(o); setOfertaEditorOpen(true); }}>✏️ Editar</Button>
                      <Button size="small" variant="outlined" color="error" onClick={() => handleBorrarOferta(o)}>🗑 Eliminar</Button>
                      <Button size="small" variant="contained" sx={{ bgcolor: '#22c55e' }} onClick={() => handleAceptarOferta(o)}>✅ Aceptar → pedido</Button>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
            {ofertas.length === 0 && <Grid item xs={12}><Alert severity="info">No hay ofertas pendientes.</Alert></Grid>}
          </Grid>
        </Box>
      )}
      
      {/* TAB PEDIDOS DE CLIENTE */}
      {tabActual === 'pedidos' && <PedidosCliente onCambio={cargarRecambios} />}

      {/* TAB MOVIMIENTOS */}
      {tabActual === 'movimientos' && (
        <Box>
          {/* Filtros */}
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Tipo</InputLabel>
                <Select value={movFiltros.tipo} label="Tipo"
                  onChange={(e) => { setMovFiltros({ ...movFiltros, tipo: e.target.value }); setMovPage(1); }}>
                  <MenuItem value="">Todos</MenuItem>
                  <MenuItem value="entrada">Entrada</MenuItem>
                  <MenuItem value="salida">Salida</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField fullWidth size="small" label="Recambio"
                value={movFiltros.recambio}
                onChange={(e) => { setMovFiltros({ ...movFiltros, recambio: e.target.value }); setMovPage(1); }} />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField fullWidth size="small" label="Motivo"
                value={movFiltros.motivo}
                onChange={(e) => { setMovFiltros({ ...movFiltros, motivo: e.target.value }); setMovPage(1); }} />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Usuario</InputLabel>
                <Select value={movFiltros.usuario_id} label="Usuario"
                  onChange={(e) => { setMovFiltros({ ...movFiltros, usuario_id: Number(e.target.value) }); setMovPage(1); }}>
                  <MenuItem value={0}>Todos</MenuItem>
                  {usuarios.map(u => <MenuItem key={u.id} value={u.id}>{u.nombre} {u.apellidos}</MenuItem>)}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField fullWidth size="small" label="Fecha desde" type="date"
                InputLabelProps={{ shrink: true }}
                value={movFiltros.fecha_inicio}
                onChange={(e) => { setMovFiltros({ ...movFiltros, fecha_inicio: e.target.value }); setMovPage(1); }} />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField fullWidth size="small" label="Fecha hasta" type="date"
                InputLabelProps={{ shrink: true }}
                value={movFiltros.fecha_fin}
                onChange={(e) => { setMovFiltros({ ...movFiltros, fecha_fin: e.target.value }); setMovPage(1); }} />
            </Grid>
            <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex', alignItems: 'center' }}>
              <Button variant="outlined" fullWidth
                onClick={() => { setMovFiltros({ tipo: '', fecha_inicio: '', fecha_fin: '', recambio: '', usuario_id: 0, motivo: '' }); setMovPage(1); }}>
                Limpiar filtros
              </Button>
            </Grid>
          </Grid>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Typography variant="body2" color="text.secondary">
              {movTotal} movimiento(s) encontrado(s)
            </Typography>
            <Button variant="outlined" size="small" onClick={exportarMovimientosExcel}
              disabled={movTotal === 0}>
              📊 Exportar Excel
            </Button>
          </Box>

          <TableContainer component={Paper} sx={{ borderRadius: 3 }}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ bgcolor: '#1a1a2e' }}>
                  {['Fecha','Tipo','Recambio','Cantidad','Total','Motivo','Usuario','Docs'].map(h => (
                    <TableCell key={h} sx={{ color: 'white' }}>{h}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {movimientos.map((m, i) => (
                  <TableRow key={i} sx={{ bgcolor: i % 2 === 0 ? 'white' : '#f9f9f9' }}>
                    <TableCell>{m.fecha?.slice(0, 10)}</TableCell>
                    <TableCell><Chip label={m.tipo} color={m.tipo === 'entrada' ? 'success' : 'error'} size="small" /></TableCell>
                    <TableCell>{m.recambio_nombre}</TableCell>
                    <TableCell>{m.cantidad}</TableCell>
                    <TableCell>{m.total?.toFixed(2)}€</TableCell>
                    <TableCell>{m.motivo}</TableCell>
                    <TableCell>{m.usuario_nombre}</TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', gap: 0.5 }}>
                        {m.oferta_id && (
                          <Button size="small" variant="text" sx={{ minWidth: 0, p: 0.5, fontSize: 11 }}
                            onClick={() => descargarPDF(`${process.env.REACT_APP_API_URL}/ofertas/${m.oferta_id}/pdf`, `${m.oferta_numero}.pdf`)}>
                            📄 Oferta
                          </Button>
                        )}
                        {m.oferta_id && m.albaran_numero && (
                          <>
                            <Button size="small" variant="text" sx={{ minWidth: 0, p: 0.5, fontSize: 11 }}
                              onClick={() => descargarPDF(`${process.env.REACT_APP_API_URL}/ofertas/${m.oferta_id}/albaran`, `${m.albaran_numero}.pdf`)}>
                              📋 Albarán
                            </Button>
                            <Button size="small" variant="text" sx={{ minWidth: 0, p: 0.5, fontSize: 11 }}
                              onClick={() => descargarPDF(`${process.env.REACT_APP_API_URL}/ofertas/${m.oferta_id}/albaran?valorado=true`, `${m.albaran_numero}_valorado.pdf`)}>
                              💰 Albarán valorado
                            </Button>
                          </>
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
                {movimientos.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      No hay movimientos con los filtros seleccionados
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Paginación */}
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 2 }}>
            <Button disabled={movPage === 1} onClick={() => setMovPage(p => p - 1)}>← Anterior</Button>
            <Typography sx={{ alignSelf: 'center' }}>Página {movPage} de {movTotalPages}</Typography>
            <Button disabled={movPage === movTotalPages} onClick={() => setMovPage(p => p + 1)}>Siguiente →</Button>
          </Box>
        </Box>
      )}

      {/* TAB PROVEEDORES */}
      {tabActual === 'proveedores' && (
        <Box>
          {puedeDarEntrada && (
            <Button variant="contained" startIcon={<AddIcon />} onClick={() => setProvDialog(true)} sx={{ mb: 2, bgcolor: '#4f46e5' }}>
              Nuevo proveedor
            </Button>
          )}
          <Grid container spacing={2}>
            {proveedores.map(p => (
              <Grid item xs={12} sm={6} key={p.id}>
                <Card sx={{ borderRadius: 3 }}>
                  <CardContent>
                    <Typography sx={{ fontWeight: 600, mb: 1 }}>🏭 {p.nombre}</Typography>
                    <Typography variant="caption" display="block">CIF: {p.cif || '—'}</Typography>
                    <Typography variant="caption" display="block">📧 {p.email || '—'}</Typography>
                    <Typography variant="caption" display="block">📞 {p.telefono || '—'}</Typography>
                    <Typography variant="caption" display="block">💳 {p.condiciones_pago}</Typography>
                    <Chip label={`${p.n_recambios} recambios`} size="small" sx={{ mt: 1 }} />
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      )}

      {/* TAB SOLICITUDES */}
      {tabActual === 'solicitudes' && (
        <Box>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
            {puedeRecibirSolicitudes ? '📋 Solicitudes de salida recibidas' : '📋 Mis solicitudes de salida'}
          </Typography>
          {solicitudes.length === 0 && <Alert severity="info">No hay solicitudes registradas.</Alert>}
          <Grid container spacing={2}>
            {solicitudes.map(s => (
              <Grid item xs={12} sm={6} key={s.id}>
                <Card sx={{ borderRadius: 3, borderLeft: `4px solid ${s.estado === 'pendiente' ? '#f59e0b' : s.estado === 'aprobada' ? '#22c55e' : '#ef4444'}` }}>
                  <CardContent>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                      <Typography sx={{ fontWeight: 600 }}>Solicitud #{s.id}</Typography>
                      <Chip label={s.estado} color={s.estado === 'pendiente' ? 'warning' : s.estado === 'aprobada' ? 'success' : 'error'} size="small" />
                    </Box>
                    <Typography variant="caption" display="block">👷 {s.solicitante_nombre} {s.solicitante_apellidos}</Typography>
                    <Typography variant="caption" display="block">📅 {s.fecha_solicitud?.slice(0, 10)}</Typography>
                    {s.cliente && <Typography variant="caption" display="block">👤 {s.cliente}</Typography>}
                    {s.motivo  && <Typography variant="caption" display="block">📝 {s.motivo}</Typography>}
                    <Box sx={{ mt: 1, pl: 1, borderLeft: '2px solid #e5e7eb' }}>
                      {s.lineas?.map((l: any) => (
                        <Typography key={l.id} variant="caption" display="block">🔩 {l.recambio_nombre} — {l.cantidad} ud.</Typography>
                      ))}
                    </Box>
                    {puedeRecibirSolicitudes && s.estado === 'pendiente' && (
                      <Box sx={{ display: 'flex', gap: 1, mt: 1.5 }}>
                        <Button size="small" variant="contained" fullWidth sx={{ bgcolor: '#22c55e' }}
                          onClick={() => {
                            setAprobarDialog(s);
                            setAprobarLineas(s.lineas?.map((l: any) => ({ ...l })) || []);
                          }}>✅ Aprobar</Button>
                        <Button size="small" variant="outlined" fullWidth color="error"
                          onClick={() => {
                            setAprobarDialog(s);
                            setAprobarLineas([]);
                          }}>✕ Rechazar</Button>
                      </Box>
                    )}
                    {s.comentario_resolucion && (
                      <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>💬 {s.comentario_resolucion}</Typography>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      )}

      {/* Carrito flotante */}
      {carrito.length > 0 && (
        <Box sx={{ position: 'fixed', bottom: 24, right: 24, zIndex: 1300 }}>
          <Button variant="contained" onClick={() => setCarritoOpen(true)}
            sx={{ bgcolor: '#4f46e5', borderRadius: 8, px: 3, py: 1.5, boxShadow: 4, '&:hover': { bgcolor: '#3730a3' } }}>
            🛒 {carrito.length} recambio(s) — Ver oferta
          </Button>
        </Box>
      )}

      {/* Dialog carrito */}
      <Dialog open={carritoOpen} onClose={(e, r) => { if (r !== 'backdropClick' && r !== 'escapeKeyDown') { setCarritoOpen(false); } }} maxWidth="md" fullWidth fullScreen={window.innerWidth < 600}>
        <DialogTitle>🛒 Oferta — {carrito.length} recambio(s)</DialogTitle>
        <DialogContent>
          <TableContainer sx={{ mb: 2 }}>
            <Table size="small">
              <TableHead>
                <TableRow>{['Referencia','Recambio','Cantidad','Precio','Total',''].map(h => <TableCell key={h}>{h}</TableCell>)}</TableRow>
              </TableHead>
              <TableBody>
                {carrito.map(item => (
                  <TableRow key={item.recambio.id}>
                    <TableCell>{item.recambio.referencia}</TableCell>
                    <TableCell>{item.recambio.nombre}</TableCell>
                    <TableCell>
                      <TextField type="number" size="small" value={item.cantidad}
                        onChange={(e) => cambiarCantidadCarrito(item.recambio.id, parseInt(e.target.value) || 1)} sx={{ width: 70 }} />
                    </TableCell>
                    <TableCell>{item.recambio.precio_venta.toFixed(2)}€</TableCell>
                    <TableCell>{(item.recambio.precio_venta * item.cantidad).toFixed(2)}€</TableCell>
                    <TableCell><Button size="small" color="error" onClick={() => quitarDelCarrito(item.recambio.id)}>✕</Button></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Autocomplete options={clientesLista} getOptionLabel={(c: any) => c.nombre}
              onChange={(_, val) => setDatosVentaCarrito({ ...datosVentaCarrito, cliente: val?.nombre || '', clienteId: val?.id || null })}
              renderInput={(params) => <TextField {...params} label="Cliente *" />} />
            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField label="Descuento (%)" type="number" fullWidth value={datosVentaCarrito.descuento}
                onChange={(e) => setDatosVentaCarrito({ ...datosVentaCarrito, descuento: parseFloat(e.target.value) || 0 })} />
              <FormControl fullWidth>
                <InputLabel>Condiciones de pago</InputLabel>
                <Select value={datosVentaCarrito.condiciones} label="Condiciones de pago"
                  onChange={(e) => setDatosVentaCarrito({ ...datosVentaCarrito, condiciones: e.target.value })}>
                  <MenuItem value="Transferencia 30 días">Transferencia 30 días</MenuItem>
                  <MenuItem value="Transferencia 60 días">Transferencia 60 días</MenuItem>
                  <MenuItem value="Contado">Contado</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <TextField label="Observaciones" multiline rows={2} value={datosVentaCarrito.observaciones}
              onChange={(e) => setDatosVentaCarrito({ ...datosVentaCarrito, observaciones: e.target.value })} />
            <Alert severity="info">
              Base: {calcularTotalCarrito().base.toFixed(2)}€ | IVA: {calcularTotalCarrito().iva.toFixed(2)}€ |
              <strong> Total: {calcularTotalCarrito().total.toFixed(2)}€</strong>
            </Alert>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCarritoOpen(false)}>Cerrar</Button>
          <Button onClick={() => setCarrito([])} color="error">Vaciar carrito</Button>
          <Button onClick={handleGenerarOfertaCarrito} variant="contained" sx={{ bgcolor: '#4f46e5' }} disabled={!datosVentaCarrito.cliente}>
            📄 Generar oferta
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog movimiento */}
      <Dialog open={!!movDialog} onClose={(e, r) => { if (r !== 'backdropClick' && r !== 'escapeKeyDown') { { setMovDialog(null); setOfertaGenerada(null);; } }}} maxWidth="sm" fullWidth>
        <DialogTitle>Registrar movimiento — {movDialog?.nombre}</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            <FormControl fullWidth>
              <InputLabel>Tipo</InputLabel>
              <Select value={movDatos.tipo} label="Tipo"
                onChange={(e) => setMovDatos({ ...movDatos, tipo: e.target.value, motivo: e.target.value === 'entrada' ? 'Stock almacén' : 'Salida a obra' } as any)}>
                {puedeDarEntrada && <MenuItem value="entrada">Entrada</MenuItem>}
                {(puedeDarEntrada || puedeDarSalida) && <MenuItem value="salida">Salida</MenuItem>}
              </Select>
            </FormControl>
            <TextField label="Cantidad" type="number" value={movDatos.cantidad}
              onChange={(e) => setMovDatos({ ...movDatos, cantidad: parseInt(e.target.value) || 1 } as any)} />
            <FormControl fullWidth>
              <InputLabel>Motivo</InputLabel>
              <Select value={movDatos.motivo} label="Motivo"
                onChange={(e) => setMovDatos({ ...movDatos, motivo: e.target.value, cliente: '' } as any)}>
                {(movDatos.tipo === 'entrada' ? motivosEntrada : motivosSalida).map(m => <MenuItem key={m} value={m}>{m}</MenuItem>)}
              </Select>
            </FormControl>
            {movDatos.motivo === 'Venta cliente' && (
              <>
                <Autocomplete options={clientesLista} getOptionLabel={(c: any) => c.nombre}
                  onChange={(_, val) => setMovDatos({ ...movDatos, cliente: val?.nombre || '', clienteId: val?.id } as any)}
                  renderInput={(params) => <TextField {...params} label="Buscar cliente *" />} />
                <TextField label="Precio unitario (€)" type="number"
                  value={(movDatos as any).precioOferta || movDialog?.precio_venta || 0}
                  onChange={(e) => setMovDatos({ ...movDatos, precioOferta: parseFloat(e.target.value) } as any)} />
                <TextField label="Descuento (%)" type="number" value={(movDatos as any).descuento || 0}
                  onChange={(e) => setMovDatos({ ...movDatos, descuento: parseFloat(e.target.value) } as any)} />
                <FormControl fullWidth>
                  <InputLabel>Condiciones de pago</InputLabel>
                  <Select value={(movDatos as any).condiciones || 'Transferencia 30 días'} label="Condiciones de pago"
                    onChange={(e) => setMovDatos({ ...movDatos, condiciones: e.target.value } as any)}>
                    <MenuItem value="Transferencia 30 días">Transferencia 30 días</MenuItem>
                    <MenuItem value="Transferencia 60 días">Transferencia 60 días</MenuItem>
                    <MenuItem value="Contado">Contado</MenuItem>
                  </Select>
                </FormControl>
                <TextField label="Observaciones" multiline rows={2} value={(movDatos as any).observaciones || ''}
                  onChange={(e) => setMovDatos({ ...movDatos, observaciones: e.target.value } as any)} />
                {ofertaGenerada && <Alert severity="success">✅ Oferta {ofertaGenerada.numero} — Total: {calcularTotal().total.toFixed(2)}€</Alert>}
              </>
            )}
            {movDatos.motivo === 'Salida a obra' && (
              <FormControl fullWidth>
                <InputLabel>Vincular a intervención (opcional)</InputLabel>
                <Select
                  value={(movDatos as any).intervencion_id || ''}
                  label="Vincular a intervención (opcional)"
                  onChange={(e) => setMovDatos({ ...movDatos, intervencion_id: e.target.value ? Number(e.target.value) : null } as any)}>
                  <MenuItem value="">Sin vincular</MenuItem>
                  {intervencionesAbiertas.map(i => (
                    <MenuItem key={i.id} value={i.id}>
                      #{i.id} — {i.maquina_modelo} ({i.cliente_nombre}) — {i.tipo_intervencion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}

            {movDatos.motivo !== 'Venta cliente' && movDatos.motivo !== 'Salida a obra' && (
              <TextField label="Nº Albarán (opcional)" value={movDatos.albaran}
                onChange={(e) => setMovDatos({ ...movDatos, albaran: e.target.value } as any)} />
            )}

            {movDatos.motivo === 'Salida a obra' && (
              <TextField label="Nº Albarán (opcional)" value={movDatos.albaran}
                onChange={(e) => setMovDatos({ ...movDatos, albaran: e.target.value } as any)} />
            )}
            {movDatos.tipo === 'salida' && movDialog && (
              <Alert severity="info">Stock actual: {movDialog.stock_actual} unidades</Alert>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setMovDialog(null); setOfertaGenerada(null); }}>Cancelar</Button>
          {movDatos.motivo === 'Venta cliente' && !ofertaGenerada && (
            <Button onClick={handleGenerarOferta} variant="outlined" disabled={!movDatos.cliente}>📄 Generar oferta</Button>
          )}
          {movDatos.motivo === 'Venta cliente' && ofertaGenerada && (
            <>
              <Button onClick={handleDescargarOferta} variant="outlined">⬇️ Descargar oferta</Button>
              <Button onClick={handleConfirmarVenta} variant="contained" sx={{ bgcolor: '#22c55e' }}>✅ Confirmar venta</Button>
            </>
          )}
          {movDatos.motivo !== 'Venta cliente' && (
            <Button onClick={handleMovimiento} variant="contained" sx={{ bgcolor: '#4f46e5' }}>Registrar</Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Dialog solicitud de salida */}
<Dialog open={!!solicitudDialog} onClose={(e, r) => { if (r !== 'backdropClick' && r !== 'escapeKeyDown') { setSolicitudDialog(null); } }} maxWidth="sm" fullWidth>
  <DialogTitle>📋 Solicitar salida — {solicitudDialog?.nombre}</DialogTitle>
  <DialogContent>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
      <Alert severity="info">
        Stock disponible: {solicitudDialog ? solicitudDialog.stock_actual - (solicitudDialog.stock_reservado || 0) : 0} unidades
      </Alert>

      <FormControl fullWidth>
        <InputLabel>Tipo de salida</InputLabel>
        <Select value={solicitudDatos.tipo_salida} label="Tipo de salida"
          onChange={(e) => setSolicitudDatos({ ...solicitudDatos, tipo_salida: e.target.value, cliente: '', clienteId: null })}>
          <MenuItem value="salida_obra">Salida a obra</MenuItem>
          <MenuItem value="venta_cliente">Venta a cliente</MenuItem>
        </Select>
      </FormControl>

      {solicitudDatos.tipo_salida === 'venta_cliente' && (
              <Autocomplete
                options={clientesLista}
                getOptionLabel={(c: any) => c.nombre}
                onChange={(_, val) => setSolicitudDatos({ ...solicitudDatos, cliente: val?.nombre || '', clienteId: val?.id || null })}
                renderInput={(params) => <TextField {...params} label="Cliente *" />}
              />
            )}

            {solicitudDatos.tipo_salida === 'salida_obra' && (
              <FormControl fullWidth>
                <InputLabel>Vincular a intervención (opcional)</InputLabel>
                <Select
                  value={solicitudDatos.intervencion_id || ''}
                  label="Vincular a intervención (opcional)"
                  onChange={(e) => setSolicitudDatos({ ...solicitudDatos, intervencion_id: e.target.value ? Number(e.target.value) : null })}>
                  <MenuItem value="">Sin vincular</MenuItem>
                  {intervencionesAbiertas.map(i => (
                    <MenuItem key={i.id} value={i.id}>
                      #{i.id} — {i.maquina_modelo} ({i.cliente_nombre}) — {i.tipo_intervencion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}

      <TextField label="Cantidad" type="number" value={solicitudDatos.cantidad}
        onChange={(e) => setSolicitudDatos({ ...solicitudDatos, cantidad: parseInt(e.target.value) || 1 })} />

      <TextField label="Motivo (opcional)" value={solicitudDatos.motivo}
        onChange={(e) => setSolicitudDatos({ ...solicitudDatos, motivo: e.target.value })}
        placeholder="Ej: Salida a obra, reparación máquina..." />
    </Box>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setSolicitudDialog(null)}>Cancelar</Button>
    <Button
      onClick={handleCrearSolicitud} variant="contained"
      sx={{ bgcolor: '#f59e0b' }}
      disabled={solicitudDatos.cantidad < 1 ||
        (solicitudDatos.tipo_salida === 'venta_cliente' && !solicitudDatos.clienteId)}
    >
      📤 Enviar solicitud
    </Button>
  </DialogActions>
</Dialog>

{/* Dialog aprobar/rechazar solicitud */}
      <Dialog open={!!aprobarDialog} onClose={(e, r) => { if (r !== 'backdropClick' && r !== 'escapeKeyDown') { setAprobarDialog(null); } }} maxWidth="sm" fullWidth>
        <DialogTitle>
          {aprobarDialog?.tipo_salida === 'venta_cliente' ? '💼 Aprobar — Venta a cliente' : '📤 Aprobar — Salida a obra'}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            <Typography variant="body2" color="text.secondary">
              Solicitado por: <strong>{aprobarDialog?.solicitante_nombre} {aprobarDialog?.solicitante_apellidos}</strong>
            </Typography>
            {aprobarDialog?.cliente && (
              <Typography variant="body2">👤 Cliente: <strong>{aprobarDialog.cliente}</strong></Typography>
            )}
            {aprobarDialog?.intervencion_id && (
              <Typography variant="body2">🔧 Intervención vinculada: <strong>#{aprobarDialog.intervencion_id}</strong></Typography>
            )}

            {/* Líneas con precio editable solo si es venta cliente */}
            <Typography variant="body2" sx={{ fontWeight: 600 }}>Líneas:</Typography>
            {aprobarLineas.map((l: any, i: number) => (
              <Box key={l.id} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography variant="body2" sx={{ flex: 1 }}>
                  🔩 {l.recambio_nombre} — {l.cantidad} ud.
                </Typography>
                {aprobarDialog?.tipo_salida === 'venta_cliente' && (
                  <TextField
                    label="Precio unit. €" type="number" size="small" sx={{ width: 130 }}
                    value={l.precio_unitario || 0}
                    onChange={(e) => {
                      const nuevas = [...aprobarLineas];
                      nuevas[i] = { ...nuevas[i], precio_unitario: parseFloat(e.target.value) || 0 };
                      setAprobarLineas(nuevas);
                    }}
                  />
                )}
              </Box>
            ))}

            {aprobarDialog?.tipo_salida !== 'venta_cliente' && (
              <Alert severity="warning">
                Al aprobar se descontará el stock inmediatamente.
              </Alert>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAprobarDialog(null)}>Cancelar</Button>
          <Button variant="outlined" color="error"
            onClick={() => handleResolverSolicitud(aprobarDialog.id, 'rechazada')}>
            ✕ Rechazar
          </Button>
          <Button variant="contained" sx={{ bgcolor: '#22c55e' }}
            onClick={() => handleResolverSolicitud(aprobarDialog.id, 'aprobada')}>
            ✅ Aprobar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog QR */}
      <Dialog open={!!qrDialog} onClose={(e, r) => { if (r !== 'backdropClick' && r !== 'escapeKeyDown') { setQrDialog(null); } }} maxWidth="xs" fullWidth>
        <DialogTitle>Código QR — {qrDialog?.nombre}</DialogTitle>
        <DialogContent sx={{ textAlign: 'center', py: 4 }}>
          {qrDialog && (
            <Box id="qr-print-area">
              <QRCodeSVG value={qrDialog.referencia} size={200} />
              <Typography sx={{ mt: 2, fontWeight: 600 }}>{qrDialog.nombre}</Typography>
              <Typography variant="caption" color="text.secondary">Ref: {qrDialog.referencia}</Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setQrDialog(null)}>Cerrar</Button>
          <Button variant="contained" sx={{ bgcolor: '#4f46e5' }} onClick={() => {
            const printContent = document.getElementById('qr-print-area')?.innerHTML;
            const ventana = window.open('', '_blank');
            if (ventana && printContent) {
              ventana.document.write(`<html><head><title>QR ${qrDialog.referencia}</title></head><body style="text-align:center;font-family:sans-serif;padding-top:40px">${printContent}</body></html>`);
              ventana.document.close(); ventana.print();
            }
          }}>🖨️ Imprimir</Button>
        </DialogActions>
      </Dialog>

      {/* Dialog proveedor */}
      <Dialog open={provDialog} onClose={(e, r) => { if (r !== 'backdropClick' && r !== 'escapeKeyDown') { setProvDialog(false); } }} maxWidth="sm" fullWidth>
        <DialogTitle>➕ Nuevo proveedor</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            <TextField label="Nombre *" value={provDatos.nombre} onChange={(e) => setProvDatos({ ...provDatos, nombre: e.target.value })} />
            <TextField label="CIF" value={provDatos.cif} onChange={(e) => setProvDatos({ ...provDatos, cif: e.target.value })} />
            <TextField label="Email" value={provDatos.email} onChange={(e) => setProvDatos({ ...provDatos, email: e.target.value })} />
            <TextField label="Teléfono" value={provDatos.telefono} onChange={(e) => setProvDatos({ ...provDatos, telefono: e.target.value })} />
            <TextField label="Contacto" value={provDatos.contacto} onChange={(e) => setProvDatos({ ...provDatos, contacto: e.target.value })} />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setProvDialog(false)}>Cancelar</Button>
          <Button onClick={handleProveedor} variant="contained" sx={{ bgcolor: '#4f46e5' }} disabled={!provDatos.nombre}>Guardar</Button>
        </DialogActions>
      </Dialog>
      {/* Dialog recambio: alta y edicion */}
      <Dialog open={recDialog} onClose={(e, r) => { if (r !== 'backdropClick') setRecDialog(false); }} maxWidth="sm" fullWidth>
        <DialogTitle>{recEditando ? '✏️ Editar recambio' : '➕ Nuevo recambio'}</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            <TextField label="Referencia *" value={recDatos.referencia}
              onChange={(e) => setRecDatos({ ...recDatos, referencia: e.target.value })} />
            <TextField label="Nombre *" value={recDatos.nombre}
              onChange={(e) => setRecDatos({ ...recDatos, nombre: e.target.value })} />
            <TextField label="Descripción" multiline rows={2} value={recDatos.descripcion}
              onChange={(e) => setRecDatos({ ...recDatos, descripcion: e.target.value })} />
            <TextField select label="División" value={recDatos.division} SelectProps={{ native: true }}
              onChange={(e) => setRecDatos({ ...recDatos, division: e.target.value })}>
              {Object.keys(conteoDiv).filter(d => d !== 'todas').map(d => (
                <option key={d} value={d}>{d}</option>
              ))}
            </TextField> 
            <TextField label="Categoría" value={recDatos.categoria}
              onChange={(e) => setRecDatos({ ...recDatos, categoria: e.target.value })} />
            <TextField label="Modelos compatibles" value={recDatos.modelos_compatibles}
              onChange={(e) => setRecDatos({ ...recDatos, modelos_compatibles: e.target.value })} />
            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField label="Precio compra €" type="number" fullWidth value={recDatos.precio_compra}
                onChange={(e) => setRecDatos({ ...recDatos, precio_compra: e.target.value })} />
              <TextField label="Precio venta €" type="number" fullWidth value={recDatos.precio_venta}
                onChange={(e) => setRecDatos({ ...recDatos, precio_venta: e.target.value })} />
            </Box>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField label="Ubicación" fullWidth value={recDatos.ubicacion_almacen}
                onChange={(e) => setRecDatos({ ...recDatos, ubicacion_almacen: e.target.value })} />
              <TextField label="Stock mínimo" type="number" fullWidth value={recDatos.stock_minimo}
                onChange={(e) => setRecDatos({ ...recDatos, stock_minimo: e.target.value })} />
            </Box>
            {!recEditando && (
              <TextField label="Stock inicial" type="number" value={recDatos.stock_inicial}
                helperText="Se registrará como movimiento de entrada"
                onChange={(e) => setRecDatos({ ...recDatos, stock_inicial: e.target.value })} />
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setRecDialog(false); setRecEditando(null); }}>Cancelar</Button>
          <Button onClick={handleGuardarRecambio} variant="contained" sx={{ bgcolor: '#4f46e5' }}
            disabled={!recDatos.referencia.trim() || !recDatos.nombre.trim()}>Guardar</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}